
export default class OrderPolicy
{
    static create(user)
    {
        return user.role_name === 'editor';
    }

    static manageOrders(user)
    {
        return user.role_name === 'admin';
    }

    static deliver(user, order)
    {
        return user.id === order.writer_id && (order.status_name === 'In progress' || order.status_name === 'Revision');
    }

    static dispute(user, order)
    {
        return user.id === order.user_id && (order.status_name === 'Delivered' || order.status_name === 'Finished');
    }
    static approve(user, order)
    {
        return user.id === order.user_id && (order.status_name === 'Delivered' || order.status_name ===  'Revision');
    }
    static confirm(user, order)
    {
        return user.id === order.writer_id && order.status_name === 'Confirmation';
    }
    static reject(user, order)
    {
        return user.id === order.writer_id && order.status_name === 'Confirmation';
    }
    static requestRevision(user, order)
    {
        return (user.id === order.user_id && (order.status_name === 'Delivered' || order.status_name ===  'Finished' || order.status_name ===  'Proofreading') && order.revision_is_available) || (user.role_name === 'editor' && user.id === order.editor_id);
    }

    static setPrice(user)
    {
        return user && (user.role_name === 'admin' || user.test === 1);
    }
    static reassignWriter(user, order)
    {
        return user.id === order.user_id && order.status_name === 'Confirmation';
    }

    static show(user, post)
    {
        return true;
    }

    static extendDeadline(user, order)
    {
        return user.id === order.user_id && order.status !== 7 && order.status !== 8;
    }

    static seeEditorDeadline(user, order)
    {
        return user.role_name === 'editor';
    }

    static createNewOrderNote(user)
    {
        return user.role_name === 'editor' || user.role_name === 'admin';
    }
    static autoTake(user, order)
    {
        return user.role_name === 'writer' && order.status_name === 'Bidding' && user.profile && user.profile.evaluation >= 7 && order.disable_autotake === 0;
    }

    // EDITOR Policies
    static takeForEditing(user, order)
    {
        return user.role_name === 'editor' && (order.status_name === 'Delivered' || order.status_name === 'Proofreading') && !order.editor_id;
    }
    static approveDeliveredFile(user, order, comment)
    {
        return user.role_name === 'editor' && (order.status_name === 'Delivered' || order.status_name === 'Proofreading') && user.id === order.editor_id && comment.commentable.status === 0; //isPending
    }
    static setDeliveredFileAsPending(user, order, comment)
    {
        return user.role_name === 'editor' && (order.status_name === 'Delivered' || order.status_name === 'Proofreading' || order.status_name === 'Revision') && user.id === order.editor_id && comment.commentable.status; //isPending
    }
    static uploadEditedFile(user, order, comment)
    {
        return user.role_name === 'editor' && (order.status_name === 'Delivered' || order.status_name === 'Proofreading') && user.id === order.editor_id && comment.commentable.status === 0; //isPending
    }
    static setAbsoluteDeadline(user)
    {
        return user.role_name === 'admin' || user.test === 1; //isPending
    }
}